// import {Country} from './invoice.model';

const Orders = [
	{
		id: '#VZ2101',
		name: 'Frank Hook',
		product: 'Puma Tshirt',
		date: '20 Dec, 2021',
		time: '02:21 AM',
		amount: '654',
		pmethod: 'Mastercard',
		status: 'PENDING',
		isSelected: false,
	},
	{
		id: '#VZ2102',
		name: 'Rickey Teran',
		product: 'Adidas Sneakers',
		date: '16 Dec, 2021',
		time: '03:41 PM',
		amount: '354',
		pmethod: 'Paypal',
		status: 'CANCELLED',
		isSelected: false,
	},
	{
		id: '#VZ2103',
		name: 'James Price',
		product: '350 ml Glass Grocery Container',
		date: '28 Nov, 2021',
		time: '11:33 AM',
		amount: '829',
		pmethod: 'Visa',
		status: 'INPROGRESS',
		isSelected: false,
	},
	{
		id: '#VZ2104',
		name: 'Nettie Deloatch',
		product: 'American egale outfitters Shirt',
		date: '22 Nov, 2021',
		time: '07:45 PM',
		amount: '142',
		pmethod: 'COD',
		status: 'PENDING',
		isSelected: false,
	},
	{
		id: '#VZ2105',
		name: 'Thomas Taylor',
		product: 'Galaxy Watch4',
		date: '12 Nov, 2021',
		time: '10:19 PM',
		amount: '408',
		pmethod: 'Mastercard',
		status: 'PICKUPS',
		isSelected: false,
	},
	{
		id: '#VZ2106',
		name: 'James Price',
		product: 'Apple iPhone 12',
		date: '05 Nov, 2021',
		time: '11:47 AM',
		amount: '1240',
		pmethod: 'Visa',
		status: 'INPROGRESS',
		isSelected: false,
	},
	{
		id: '#VZ2107',
		name: 'Nancy Martino',
		product: 'Funky Prints T-shirt',
		date: '31 Oct, 2021',
		time: '08:55 PM',
		amount: '180',
		pmethod: 'COD',
		status: 'RETURNS',
		isSelected: false,
	},
	{
		id: '#VZ2108',
		name: 'Alexis Clarke',
		product: 'USB Flash Drive Personalized with 3D Print',
		date: '25 Oct, 2021',
		time: '05:33 AM',
		amount: '247',
		pmethod: 'Paypal',
		status: 'DELIVERED',
		isSelected: false,
	},
	{
		id: '#VZ2109',
		name: 'Donald Palmer',
		product: 'Oxford Button-Down Shirt',
		date: '19 Oct, 2021',
		time: '12:43 AM',
		amount: '373',
		pmethod: 'Visa',
		status: 'PICKUPS',
		isSelected: false,
	},
	{
		id: '#VZ2110',
		name: 'Henry Baird',
		product: 'Classic Short Sleeve Shirt',
		date: '13 Oct, 2021',
		time: '01:20 PM',
		amount: '342',
		pmethod: 'Mastercard',
		status: 'INPROGRESS',
		isSelected: false,
	},
	{
		id: '#VZ2111',
		name: 'Diana Kohler',
		product: 'Half Sleeve T-Shirts (Blue)',
		date: '01 Oct, 2021',
		time: '03:08 AM',
		amount: '874',
		pmethod: 'Visa',
		status: 'DELIVERED',
		isSelected: false,
	},
	{
		id: '#VZ2112',
		name: 'Alexis Clarke',
		product: 'Noise Evolve Smartwatch',
		date: '29 Sep, 2021',
		time: '04:24 AM',
		amount: '1021',
		pmethod: 'Mastercard',
		status: 'CANCELLED',
		isSelected: false,
	},
];

export { Orders };
